import { Customer } from '@medusajs/medusa'
import { BHTag } from '@modules/bh/components'
import Link from 'next/link'

interface AccountApprovalMessageProps {
  isApproved: boolean
  isRejected: boolean
  isSetUp: boolean
  customer?: Omit<Customer, 'password_hash'>
}
function AccountApprovalMessage({
  isApproved,
  isRejected,
  isSetUp,
  customer,
}: AccountApprovalMessageProps) {
  return (
    <>
      {isRejected && (
        <div className="w-full m-4 bg-red-100 p-2 rounded-md text-red-700 border border-red-400">
          Your application for an account with Barnhill has been rejected. If
          you believe this is a mistake or have questions, please contact
          Barnhill Supply.
        </div>
      )}

      {!isSetUp && !isRejected ? (
        // Account is not set up
        <div>
          {customer && (
            <div className="w-1/2 m-4 border-yellow-500 border bg-yellow-100 p-3 rounded-md">
              <div className="">
                <span></span>
                Before you can get quotes or place orders, a few things need to
                be set up for your account to be approved. To start,{' '}
                <Link
                  className="font-bold underline cursor-pointer"
                  href="/account/addresses?initialSetup=true"
                >
                  <a className="underline">enter a Shipping Address</a>
                </Link>
              </div>
            </div>
          )}

          {customer && !customer.phone && (
            <Link href="/account/profile">
              <div className="w-1/2 m-4 border-yellow-500 border bg-yellow-100 p-3 rounded-md">
                <span className="text-base-large text-black-500">
                  <span className="font-bold">Phone Incomplete</span>
                  Add the phone number by which you would like to be contacted
                  concerning orders.
                </span>
              </div>
            </Link>
          )}
        </div>
      ) : !isApproved && !isRejected ? (
        // Account is set up, but not approved
        <>
          <BHTag status="warning" text="Pending Approval" />

          <div className="w-full m-4 bg-yellow-100 p-2 rounded-md">
            Your account is now pending approval from Barnhill. Once approved, you will receive an email notification and you will be able to get quotes and order products through our website.
          </div>
        </>
      ) : (
        !isRejected && (
          // Account is set up and approved
          <BHTag status="success" text="Approved" />
        )
      )}
    </>
  )
}

export default AccountApprovalMessage
